class SolviaReviews extends HTMLElement {
  connectedCallback() {
    this.observer = new MutationObserver(() => this.updateSummary());
    this.observer.observe(this, { childList: true, subtree: true, characterData: true });
    this.updateSummary();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  updateSummary() {
    const ratingDisplay = this.querySelector('.jm-average-rating-display');
    const values = ratingDisplay?.querySelectorAll(':scope > .jm-cluster > p');
    if (!values?.length) return;
    const rating = Number.parseFloat(values[0].textContent);
    if (Number.isFinite(rating)) {
      ratingDisplay.style.setProperty('--solvia-rating-fill', `${Math.max(0, Math.min(5, rating)) * 20}%`);
    }
    const count = values[1]?.textContent.match(/[\d,]+/)?.[0];
    const summary = this.querySelector('[data-review-summary]');
    if (summary && count) {
      const label = `レビュー（${count}）`;
      if (summary.textContent !== label) summary.textContent = label;
    }
  }
}

if (!customElements.get('solvia-reviews')) customElements.define('solvia-reviews', SolviaReviews);
